import { select } from "@ngrx/store";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";

import { CoreState } from "../state";

import { AuthenticationStatus, AuthState } from "./auth.model";

export namespace AuthSelector {
	export const getState = (state: CoreState): AuthState => state.auth;

	export const isAuthenticated = (state: CoreState): boolean => !!state.auth.isAuthenticated;

	export const isAuthenticated$ = (state$: Observable<CoreState>): Observable<boolean> =>
		state$.pipe(
			select(getAuthenticationStatus),
			distinctUntilChanged(),
			filter((status) => status !== AuthenticationStatus.Pending),
			map((status) => status === AuthenticationStatus.Authenticated)
		);

	export const getAuthenticationStatus = (state: CoreState): AuthenticationStatus => {
		if (state.auth.isAuthenticated) {
			return AuthenticationStatus.Authenticated;
		}
		if (state.auth.isAuthenticated === false) {
			return AuthenticationStatus.NotAuthenticated;
		}
		return AuthenticationStatus.Pending;
	};

	export const isFirstLogin = (state: CoreState): boolean | undefined => state.auth.isFirstLogin;

	export const getSessionLimitCheckPeriodInMilis = (state: CoreState): number | undefined =>
		state.auth.sessionLimitCheckPeriodInMillis;

	// this is kind of a dangerous selector and probably should not be used
	export const getSessionElapsedTimeInMillis = (state: CoreState): number | undefined => {
		const time = state.auth.sessionStartTimeInMillis;

		return time === undefined ? undefined : Date.now() - time;
	};

	export const getSessionStartTimeInMillis = (state: CoreState): number | undefined => {
		return state.auth.sessionStartTimeInMillis;
	};

	export const getSessionToken = (state: CoreState): string | undefined => state.auth.token;

	export const getAuthenticationToken = (state: CoreState): string | undefined => state.auth.authenticationToken;
}
